import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DataCopyWrapperDirective } from '../directives/formElements/dashboardTemplates/data-copy.wrapper.directive';
import { PageProgressIndicatorComponent } from './page-progress-indicator.component';
import { ProgressIndicatorComponent } from './progress-indicator.component';
import { SvgIconComponent } from './svg-icon.component';
import { BadgeComponent } from './badge.component';
import { ChevronComponent } from './chevron.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { PipesModule } from '../pipes/pipes.module';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { DialogComponent } from './dialog/dialog.component';
import { DialogActionsDirective } from './dialog/dialog-actions.directive';
import { DialogContentDirective } from './dialog/dialog-content.directive';
import { DialogTitleDirective } from './dialog/dialog-title.directive';


@NgModule({
    imports: [
        CommonModule,
        PipesModule,
    ],
    declarations: [
        SvgIconComponent,
        BadgeComponent,
        ChevronComponent,
        DataCopyWrapperDirective,
        ProgressIndicatorComponent,
        PageProgressIndicatorComponent,
        DropdownComponent,
        DialogTitleDirective,
        DialogContentDirective,
        DialogActionsDirective,
        DialogComponent,
        ConfirmDialogComponent,
    ],
    exports: [
        SvgIconComponent,
        BadgeComponent,
        ChevronComponent,
        DataCopyWrapperDirective,
        ProgressIndicatorComponent,
        PageProgressIndicatorComponent,
        DropdownComponent,
        DialogTitleDirective,
        DialogContentDirective,
        DialogActionsDirective,
        DialogComponent,
        ConfirmDialogComponent,
    ],
})
export class SharedComponentsModule { }